// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("cursor.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/handpointing.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  color: var(--text-color);
  transition: background-color 0.3s, color 0.3s; 
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), auto; 
}

body {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), auto;
}

a, button, [role="button"], label {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_1___}), pointer; 
}


.back-button {
  position: absolute;
  top: 0;
  left: 0;
  background-color: transparent;
  border: 0px;
  font-size: 140%;
  margin-top: 20px;
  margin-left: 20px;
  color: var(--text-color);
  transition: color 0.3s; 
}

.back-button:hover {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_1___}), pointer; 
}


.elohere-title:hover {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_1___}), pointer; 
}

.skins-title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 300%;
  text-decoration: none;
  color: var(--text-color);
  transition: color 0.3s; 
}

.avatar {
  width: 75px;
  margin-left: 20px;
}

.skins-link {
  justify-content: center;
  align-items: center;
  display: flex;
  text-decoration: none;
  color: var(--text-color);
  transition: color 0.3s; 
}

.skins {
  justify-content: center;
  align-items: center;
  display: flex;
  flex-wrap: wrap; 
}

.bdt p {
  justify-content: center;
  align-items: center;
  display: flex;
  text-decoration: none;
  color: var(--text-color);
  font-size: 120%;
  transition: color 0.3s; 
}

.bdt img {
  width: 300px;
}

.elohere_be p {
  justify-content: center;
  align-items: center;
  display: flex;
  text-decoration: none;
  color: var(--text-color);
  font-size: 120%;
  margin-left: 20px;
  transition: color 0.3s; 
}

.elohere_be img {
  width: 300px;
  margin-left: 30px;
}

.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: var(--footer-background-color);
  text-align: center;
  padding: 10px 0;
  box-shadow: 0 -2px 5px rgba(0,0,0,0.1);
  color: var(--text-color);
  transition: background-color 0.3s, color 0.3s; 
}

.toggle-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_1___}), pointer;
  transition: transform 0.3s ease, color 0.3s; 
  margin-left: 10px; 
  color: var(--text-color);
}

.toggle-button:focus {
  outline: none;
}

.toggle-button.rotate {
  transform: rotate(180deg);
}

.skins-container {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.5s ease-out, opacity 0.5s ease-out;
  opacity: 0;
}

.skins-container.expanded {
  max-height: 1000px; 
  opacity: 1;
}

/* Responsive Styles */
@media (max-width: 1200px) {
  .skins-title {
    font-size: 250%;
  }

  .bdt img, .elohere_be img {
    width: 250px;
  }
}

@media (max-width: 992px) {
  .skins-title {
    font-size: 200%;
  }

  .bdt img, .elohere_be img {
    width: 200px;
  }
}

@media (max-width: 768px) {
  .skins-title {
    font-size: 150%;
  }

  .bdt img, .elohere_be img {
    width: 150px;
  }

  .elohere_be p {
    margin-left: 10px;
  }
}

@media (max-width: 576px) {
  .skins-title {
    font-size: 120%;
  }

  .bdt img, .elohere_be img {
    width: 100%; 
  }

  .elohere_be p {
    margin-left: 5px;
  }

  .skins {
    flex-direction: column; 
    align-items: center; 
  }

  .bdt, .elohere_be {
    width: 100%; 
    margin-bottom: 20px; 
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .bdt img, .elohere_be img {
    width: 100%; 
    max-width: 300px; 
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Skins.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,6CAA6C;EAC7C,qDAA+B;AACjC;;AAEA;EACE,qDAA+B;AACjC;;AAEA;EACE,wDAAkD;AACpD;;;AAGA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,6BAA6B;EAC7B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,wDAAkD;AACpD;;;AAGA;EACE,wDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,gDAAgD;EAChD,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wDAAkD;EAClD,2CAA2C;EAC3C,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2DAA2D;EAC3D,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":["* {\n  color: var(--text-color);\n  transition: background-color 0.3s, color 0.3s; \n  cursor: url('cursor.png'), auto; \n}\n\nbody {\n  cursor: url('cursor.png'), auto;\n}\n\na, button, [role=\"button\"], label {\n  cursor: url('../assets/handpointing.png'), pointer; \n}\n\n\n.back-button {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: transparent;\n  border: 0px;\n  font-size: 140%;\n  margin-top: 20px;\n  margin-left: 20px;\n  color: var(--text-color);\n  transition: color 0.3s; \n}\n\n.back-button:hover {\n  cursor: url('../assets/handpointing.png'), pointer; \n}\n\n\n.elohere-title:hover {\n  cursor: url('../assets/handpointing.png'), pointer; \n}\n\n.skins-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 300%;\n  text-decoration: none;\n  color: var(--text-color);\n  transition: color 0.3s; \n}\n\n.avatar {\n  width: 75px;\n  margin-left: 20px;\n}\n\n.skins-link {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  text-decoration: none;\n  color: var(--text-color);\n  transition: color 0.3s; \n}\n\n.skins {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap; \n}\n\n.bdt p {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  text-decoration: none;\n  color: var(--text-color);\n  font-size: 120%;\n  transition: color 0.3s; \n}\n\n.bdt img {\n  width: 300px;\n}\n\n.elohere_be p {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  text-decoration: none;\n  color: var(--text-color);\n  font-size: 120%;\n  margin-left: 20px;\n  transition: color 0.3s; \n}\n\n.elohere_be img {\n  width: 300px;\n  margin-left: 30px;\n}\n\n.footer {\n  position: fixed;\n  bottom: 0;\n  width: 100%;\n  background-color: var(--footer-background-color);\n  text-align: center;\n  padding: 10px 0;\n  box-shadow: 0 -2px 5px rgba(0,0,0,0.1);\n  color: var(--text-color);\n  transition: background-color 0.3s, color 0.3s; \n}\n\n.toggle-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: url('../assets/handpointing.png'), pointer;\n  transition: transform 0.3s ease, color 0.3s; \n  margin-left: 10px; \n  color: var(--text-color);\n}\n\n.toggle-button:focus {\n  outline: none;\n}\n\n.toggle-button.rotate {\n  transform: rotate(180deg);\n}\n\n.skins-container {\n  overflow: hidden;\n  max-height: 0;\n  transition: max-height 0.5s ease-out, opacity 0.5s ease-out;\n  opacity: 0;\n}\n\n.skins-container.expanded {\n  max-height: 1000px; \n  opacity: 1;\n}\n\n/* Responsive Styles */\n@media (max-width: 1200px) {\n  .skins-title {\n    font-size: 250%;\n  }\n\n  .bdt img, .elohere_be img {\n    width: 250px;\n  }\n}\n\n@media (max-width: 992px) {\n  .skins-title {\n    font-size: 200%;\n  }\n\n  .bdt img, .elohere_be img {\n    width: 200px;\n  }\n}\n\n@media (max-width: 768px) {\n  .skins-title {\n    font-size: 150%;\n  }\n\n  .bdt img, .elohere_be img {\n    width: 150px;\n  }\n\n  .elohere_be p {\n    margin-left: 10px;\n  }\n}\n\n@media (max-width: 576px) {\n  .skins-title {\n    font-size: 120%;\n  }\n\n  .bdt img, .elohere_be img {\n    width: 100%; \n  }\n\n  .elohere_be p {\n    margin-left: 5px;\n  }\n\n  .skins {\n    flex-direction: column; \n    align-items: center; \n  }\n\n  .bdt, .elohere_be {\n    width: 100%; \n    margin-bottom: 20px; \n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .bdt img, .elohere_be img {\n    width: 100%; \n    max-width: 300px; \n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
